import * as React from "react";

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onCheckedChange?: (checked: boolean) => void;
}

export function Switch({ onCheckedChange, ...props }: SwitchProps) {
  return (
    <input
      type="checkbox"
      {...props}
      onChange={(e) => {
        onCheckedChange?.(e.target.checked);
        props.onChange?.(e);
      }}
    />
  );
}
